import React, { useMemo } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { useEventContext } from '../../../../context/EventContext';
import getFullname from '../../../../helpers/get-fullname';
import getMemberNickname from '../../../../helpers/get-member-nickname';
import MemberPhoto from '../../MembersComponents/MemberPhoto';
import { CButton, CTags } from '../../../UI';

import './style.scss';

/**
 * 
 * @param {array} members Array of members 
 * @param {string} viewType Type of members view: tile or line
 * @param {function} onMemberClick Callback on member click. Returns target member
 * @param {funciton} onMessageClick Callback on click button for ask a question. Returns target member
 * @returns {reactComponent}
 */
const MembersScheduleModalView = ({episode = null, photoVisible = true, viewType = 'tile', onMemberClick = null, onMessageClick = null}) => {
    if (!episode.groups.length) {
        return null;
    }

    const $locale = useLocaleContext();
    const {event} = useEventContext();
    const {moduleEpisode} = event || {};

    const episodeGroups = useMemo(() => {
        return episode.groups.map((group) => ({
            ...group,
            members: group.members.filter(({member}) => !member.hide)
        }));
    }, [episode]);

    function handleMemberClick(member) {
        if (!onMemberClick) return;

        onMemberClick(member);
    }

    if (!moduleEpisode?.membersEnabled) return null;

    return (
        <div className="members-view">
            {
                episodeGroups.map((group, index) => (
                    <div key={group.id}>
                        {
                            !!group.members.length &&
                            <>
                                <div className="members-view__type">
                                    {$locale.getProperty(group.role, group.members.length > 1 ? 'groupTitle' : 'title')}
                                </div>
                                <div className={`members-view__list members-view__list--${viewType}`}>
                                    {
                                        group.members.map((currentMember) => (
                                            <div
                                                key={currentMember.member.id}
                                                className="members-view-member"
                                            >
                                                {
                                                    photoVisible &&
                                                    <div className="members-view-member__photo">
                                                        <MemberPhoto
                                                            photo={currentMember.member?.previewUrl}
                                                            initials={getMemberNickname(currentMember.member, $locale)}
                                                            size="lg"
                                                            onClick={() => handleMemberClick(currentMember.member)}
                                                        />
                                                    </div>
                                                }
                                                <div className="members-view-member__info">
                                                    {/* <CTags
                                                        tags={member.roles}
                                                        size="small"
                                                    /> */}
                                                    <a
                                                        href=""
                                                        className="members-view-member__info-name"
                                                        onClick={(e) => {e.preventDefault(); handleMemberClick(currentMember.member);}}
                                                    >
                                                        {getFullname(currentMember.member, $locale)}
                                                    </a>
                                                    <div>
                                                        <p className="members-view-member__info-company">
                                                            {$locale.getProperty(currentMember.member, 'company')}
                                                        </p>
                                                        <p className="members-view-member__info-regalia">
                                                            {$locale.getProperty(currentMember.member, 'regalia')}
                                                        </p>
                                                    </div>
                                                    {
                                                        !!$locale.getProperty(currentMember, 'topic') &&
                                                        <p className="members-view-member__info-theme">
                                                            <span className="members-view-member__info-theme-title">
                                                                {$locale.get('member.label.theme')}:&nbsp;
                                                            </span>
                                                            {$locale.getProperty(currentMember, 'topic')}
                                                        </p>
                                                    }
                                                    {
                                                        (!!onMessageClick && currentMember.member.allowQuestions) &&
                                                        <CButton
                                                            blank
                                                            icon="message"
                                                            label={$locale.get('label.question.ask')}
                                                            className="members-view-member__info-question"
                                                            onClick={() => onMessageClick(currentMember.member)}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </>
                        }
                    </div>
                ))
            }
        </div>
    )
};

export default MembersScheduleModalView;
